const GA_MEASUREMENT_ID = 'G-Y5Q49PF78T';
let gtagInitialized = false;
let gtagScriptLoaded = false;

export function setupAnalytics(router) {
  // Wir laden das Script später manuell bei Consent
  // Speichere Router für spätere Verwendung
  window.__vueRouter = router;
}

// Lade Google Analytics Script dynamisch
function loadGtagScript() {
  return new Promise((resolve, reject) => {
    if (gtagScriptLoaded) {
      resolve();
      return;
    }

    // Erstelle gtag Script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    script.onload = () => {
      // Initialisiere gtag
      window.dataLayer = window.dataLayer || [];
      window.gtag = function() {
        window.dataLayer.push(arguments);
      };

      // Setze default consent auf denied
      window.gtag('consent', 'default', {
        'analytics_storage': 'denied'
      });

      window.gtag('js', new Date());

      gtagScriptLoaded = true;
      resolve();
    };
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

export async function enableAnalytics() {
  if (gtagInitialized) {
    console.log('⚠️ Google Analytics already initialized');
    return;
  }

  try {
    // Lade Script falls noch nicht geladen
    await loadGtagScript();

    // Update consent
    window.gtag('consent', 'update', {
      'analytics_storage': 'granted'
    });

    // Konfiguriere GA4
    window.gtag('config', GA_MEASUREMENT_ID, {
      'page_path': window.location.pathname,
      'anonymize_ip': true,
      'send_page_view': true
    });

    // Track Router changes
    if (window.__vueRouter) {
      window.__vueRouter.afterEach((to) => {
        window.gtag('config', GA_MEASUREMENT_ID, {
          'page_path': to.path,
          'page_title': to.meta.title || document.title
        });
      });
    }

    gtagInitialized = true;
  } catch (error) {
    console.error('❌ Failed to load Google Analytics:', error);
  }
}

export function disableAnalytics() {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('consent', 'update', {
      'analytics_storage': 'denied'
    });
    gtagInitialized = false;
    console.log('❌ Google Analytics deactivated');

    // Lösche GA Cookies
    document.cookie.split(";").forEach((c) => {
      if (c.trim().startsWith('_ga')) {
        const cookieName = c.split('=')[0].trim();
        document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      }
    });

  }
}

export function isAnalyticsEnabled() {
  return gtagInitialized;
}
